import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
    isLoggedIn: boolean;
    isLoading: boolean;
    // Where the open tab listens for the admin app ending this session; null
    // for Atlassian sessions or when the admin app gave none.
    adminEventsUrl: string | null;
}

const initialState: AuthState = {
    isLoggedIn: false,
    isLoading: true,
    adminEventsUrl: null,
};

export const authState = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoginState: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setAdminEventsUrl: (state, action: PayloadAction<string | null | undefined>) => {
            state.adminEventsUrl = action.payload ?? null;
        },
    },
});

export const { setAdminEventsUrl, setIsLoading, setLoginState } = authState.actions;
export default authState.reducer;
